// extracted by mini-css-extract-plugin
export default {"homeLink":"dcc_notFound-homeLink"};